import React from "react";
import imageUpload from "assets/svgs/imageUpload.svg";
import removeImg from "assets/svgs/close.svg";
import server from "api/server";
import { checkFileType, handleImage } from "helpers/functions";
import { FormattedMessage } from "react-intl";

const ImageUpload = ({
  selectedImageEn,
  setSelectedImageEn,
  accept = "image/*",
  className = "",
}) => {
  const imageChange = async (e) => {
    if (e.target.files && e.target.files.length > 0) {
      const formData = new FormData();
      formData.append("file", e.target.files[0]);
      const { data } = await server().post("/upload", formData);

      setSelectedImageEn({
        preview: e.target.file,
        path: process.env.REACT_APP_URL + data.data.file.path,
      });
    }
  };

  const removeSelectedImage = () => {
    setSelectedImageEn("");
  };

  return (
    <div className={`image-uploader image-contain ${className}`}>
      <div className="img-pat">
        <img src={imageUpload} width={46} height={46} alt="" />
      </div>
      <label>
        {(selectedImageEn?.preview || selectedImageEn?.path) && (
          <div>
            {accept?.includes("image") ? (
              <MediaShow
                image={
                  handleImage(selectedImageEn?.path) || selectedImageEn?.preview
                }
              />
            ) : (
              selectedImageEn?.path && (
                <a
                  href={handleImage(selectedImageEn?.path)}
                  target="_blank"
                  rel="noreferrer"
                >
                  <FormattedMessage id={"showFile"} />
                </a>
              )
            )}
            <button
              className="removeImg"
              onClick={removeSelectedImage}
              type="button"
              aria-label="Remove Image"
            >
              <img src={removeImg} alt="" />
            </button>
          </div>
        )}
        <input accept={accept} type="file" onChange={imageChange} />
      </label>
    </div>
  );
};

export const MediaShow = ({ image, style }) =>
  checkFileType(image) === "img" ? (
    <img
      src={
        image?.preview
          ? URL.createObjectURL(image.preview)
          : image
          ? handleImage(image)
          : imageUpload
      }
      width={200}
      height={140}
      style={style}
      alt=""
    />
  ) : (
    <video
      src={handleImage(image)}
      width={200}
      height={140}
      style={style}
      controls
      alt=""
    />
  );

export default ImageUpload;
